import { LIB_ERROR_MESSAGES } from "./libMessages";

export const ERROR_MESSAGES = {
  lib: LIB_ERROR_MESSAGES,
  cli: {},
};
